import { render, staticRenderFns } from "./ModalAddShipment.vue?vue&type=template&id=157aaf46&scoped=true&"
import script from "./ModalAddShipment.vue?vue&type=script&lang=js&"
export * from "./ModalAddShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157aaf46",
  null
  
)

export default component.exports